var _path, _path2, _rect, _rect2, _g, _rect3, _g2, _path3, _path4, _path5, _path6, _path7, _rect4, _rect5, _g3, _rect6, _g4, _rect7, _path8, _rect8, _g5, _rect9, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpaFooterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 57,
    viewBox: "0 0 49 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7091 0.924567C23.6286 0.35772 24.7891 0.35772 25.7086 0.924568L47.0518 14.0825C47.8959 14.6028 48.4099 15.5236 48.4099 16.5151V40.4845C48.4099 41.4761 47.8959 42.3969 47.0518 42.9172L25.7086 56.0751C24.7891 56.642 23.6286 56.642 22.7091 56.0751L1.3659 42.9172C0.521821 42.3969 0.0078125 41.4761 0.0078125 40.4845V16.5151C0.0078125 15.5236 0.521822 14.6028 1.3659 14.0825L22.7091 0.924567Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_2244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 57
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7013 0.924567C23.6208 0.35772 24.7813 0.35772 25.7007 0.924567L47.044 14.0825C47.888 14.6028 48.4021 15.5236 48.4021 16.5151V40.4845C48.4021 41.4761 47.888 42.3969 47.044 42.9172L25.7007 56.0751C24.7813 56.642 23.6208 56.642 22.7013 56.0751L1.35809 42.9172C0.514008 42.3969 0 41.4761 0 40.4845V16.5151C0 15.5236 0.51401 14.6028 1.35809 14.0825L22.7013 0.924567Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_2244)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3672,
    y: 27.127,
    width: 4.34096,
    height: 26.457,
    fill: "#3940A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_74_2244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 17,
    width: 9,
    height: 5
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6875,
    y: 17.1465,
    width: 4.2867,
    height: 8.68192,
    transform: "rotate(90 24.6875 17.1465)",
    fill: "#CD6767"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_74_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0056 21.4332C16.0056 20.8702 16.1179 20.3128 16.336 19.7927C16.5542 19.2726 16.8739 18.8001 17.277 18.402C17.6801 18.004 18.1587 17.6882 18.6853 17.4728C19.212 17.2574 19.7765 17.1465 20.3465 17.1465L20.3465 21.4332L16.0056 21.4332Z",
    fill: "#3940A0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_74_2244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 10,
    height: 5
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4062,
    y: 17.1465,
    width: 4.2867,
    height: 8.68192,
    rx: 0.178613,
    transform: "rotate(90 32.4062 17.1465)",
    fill: "#CD6767"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_74_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9029 21.4332C23.8043 21.4332 23.7239 21.3531 23.7281 21.2546C23.7733 20.1826 24.2244 19.1637 24.9958 18.402C25.8099 17.5981 26.914 17.1465 28.0653 17.1465C29.2166 17.1465 30.3207 17.5981 31.1348 18.402C31.9062 19.1637 32.3573 20.1826 32.4025 21.2546C32.4066 21.3531 32.3263 21.4332 32.2276 21.4332L28.0653 21.4332L23.9029 21.4332Z",
    fill: "#3940A0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6729 33.0205C26.7716 33.0205 26.8516 33.1005 26.8516 33.1991L26.8516 37.1286C26.8516 37.2272 26.7716 37.3072 26.6729 37.3072L14.7104 37.3072L14.7104 33.0205L26.6729 33.0205Z",
    fill: "#3940A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4219 38.5801L28.0809 38.5801L28.0809 28.4438C28.0809 28.3452 28.1609 28.2652 28.2595 28.2652L32.2433 28.2652C32.3419 28.2652 32.4219 28.3452 32.4219 28.4438L32.4219 38.5801Z",
    fill: "#3940A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.4316L20.341 21.4316L20.341 31.5679C20.341 31.6665 20.261 31.7465 20.1623 31.7465L16.1786 31.7465C16.08 31.7465 16 31.6665 16 31.5679L16 21.4316Z",
    fill: "#3940A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7031 22.7051L33.7031 26.9918L21.8084 26.9918C21.7098 26.9918 21.6298 26.9118 21.6298 26.8132L21.6298 22.8837C21.6298 22.785 21.7098 22.7051 21.8084 22.7051L33.7031 22.7051Z",
    fill: "#3940A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0781 38.5801L28.0781 42.8668L16.0048 42.8668L16.0048 38.7587C16.0048 38.66 16.0848 38.5801 16.1834 38.5801L28.0781 38.5801Z",
    fill: "#3940A0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0156,
    y: 17.1465,
    width: 4.2867,
    height: 7.66451,
    transform: "rotate(90 28.0156 17.1465)",
    fill: "#3940A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_74_2244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 22,
    width: 6,
    height: 10
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0312,
    y: 31.2783,
    width: 4.34096,
    height: 8.5734,
    transform: "rotate(-180 38.0312 31.2783)",
    fill: "#CD6767"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_74_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6903 22.7049C34.8416 22.7049 35.9457 23.1566 36.7598 23.9605C37.5739 24.7644 38.0313 25.8547 38.0313 26.9916L33.6903 26.9916L33.6903 22.7049Z",
    fill: "#3940A0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_74_2244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 30,
    width: 6,
    height: 9
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0469,
    y: 38.9141,
    width: 4.34096,
    height: 8.5734,
    rx: 0.178613,
    transform: "rotate(-180 38.0469 38.9141)",
    fill: "#CD6767"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_74_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7059 30.5193C33.7059 30.4206 33.7859 30.3403 33.8845 30.3443C34.9709 30.3884 36.0035 30.834 36.7754 31.5962C37.5895 32.4001 38.0469 33.4905 38.0469 34.6274C38.0469 35.7643 37.5895 36.8546 36.7754 37.6585C36.0035 38.4208 34.9709 38.8663 33.8845 38.9104C33.7859 38.9144 33.7059 38.8341 33.7059 38.7354L33.7059 34.6274L33.7059 30.5193Z",
    fill: "#3940A0"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0469,
    y: 34.627,
    width: 4.34096,
    height: 7.63568,
    transform: "rotate(-180 38.0469 34.627)",
    fill: "#3940A0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0078 42.8662H20.3488V56.3514C20.3488 56.4501 20.2688 56.5301 20.1702 56.5301H16.1864C16.0878 56.5301 16.0078 56.4501 16.0078 56.3514L16.0078 42.8662Z",
    fill: "#3940A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_74_2244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 22,
    width: 5,
    height: 10
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3672,
    y: 22.8408,
    width: 4.34096,
    height: 8.5734,
    rx: 0.178613,
    fill: "#CD6767"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_74_2244)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.7081,
    cy: 27.1275,
    rx: 4.34096,
    ry: 4.2867,
    fill: "#3940A0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_74_2244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 38,
    width: 5,
    height: 5
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0781,
    y: 42.8662,
    width: 4.2867,
    height: 4.34096,
    transform: "rotate(-90 28.0781 42.8662)",
    fill: "#CD6767"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_74_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4007 38.5795C32.4007 39.1424 32.2884 39.6999 32.0702 40.22C31.8521 40.74 31.5323 41.2126 31.1292 41.6107C30.7261 42.0087 30.2476 42.3245 29.7209 42.5399C29.1943 42.7553 28.6298 42.8662 28.0597 42.8662L28.0597 38.5795L32.4007 38.5795Z",
    fill: "#3940A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpaFooterLogo);
export default __webpack_public_path__ + "static/media/ppa-footer-logo.d0c08dd28e348c88c8feb00acd0e7c62.svg";
export { ForwardRef as ReactComponent };